import type { ReactNode } from "react";
import { NavLink } from "react-router-dom";
import { useI18n } from "@/i18n";
import { useAuth } from "@/features/auth/AuthContext";

const navItem =
  "flex flex-1 flex-col items-center justify-center gap-1 py-2 text-xs font-medium";

export function AppShell({ children }: { children: ReactNode }) {
  const { t, lang, setLang } = useI18n();
  const { wallet } = useAuth();

  return (
    <div className="mx-auto flex min-h-screen max-w-2xl flex-col">
      {/* Top bar */}
      <header className="sticky top-0 z-10 flex items-center justify-between border-b border-slate-100 bg-white/80 px-4 py-3 backdrop-blur">
        <span className="text-lg font-bold text-accent">{t("appName")}</span>
        <div className="flex items-center gap-3">
          <span className="rounded-full bg-accent-soft px-3 py-1 text-xs font-semibold text-accent">
            {wallet?.balance ?? 0} ⓒ
          </span>
          <button
            className="text-xs text-muted"
            onClick={() => setLang(lang === "ar" ? "en" : "ar")}
          >
            {lang === "ar" ? "EN" : "ع"}
          </button>
        </div>
      </header>

      <main className="flex-1 px-4 py-4 pb-24">{children}</main>

      {/* Bottom nav (mobile-first) */}
      <nav className="fixed inset-x-0 bottom-0 z-10 mx-auto flex max-w-2xl border-t border-slate-100 bg-white">
        <NavLink
          to="/"
          end
          className={({ isActive }) =>
            `${navItem} ${isActive ? "text-accent" : "text-muted"}`
          }
        >
          ✦<span>{t("navCreate")}</span>
        </NavLink>
        <NavLink
          to="/library"
          className={({ isActive }) =>
            `${navItem} ${isActive ? "text-accent" : "text-muted"}`
          }
        >
          ▦<span>{t("navLibrary")}</span>
        </NavLink>
        <NavLink
          to="/profile"
          className={({ isActive }) =>
            `${navItem} ${isActive ? "text-accent" : "text-muted"}`
          }
        >
          ◓<span>{t("navProfile")}</span>
        </NavLink>
        <NavLink
          to="/account"
          className={({ isActive }) =>
            `${navItem} ${isActive ? "text-accent" : "text-muted"}`
          }
        >
          ⚙<span>{t("navAccount")}</span>
        </NavLink>
      </nav>
    </div>
  );
}
